import { Field, Formik } from 'formik';
import { FormHelperText } from '@mui/material';
import { object, ref, string } from 'yup';
import React from 'react';
import getMessage from '../../utils/getMessage';
import { FormWrapperDiv, StyledForm } from './PasswordChangeInterfaces';
import { localizedNotifyError, localizedNotifySuccess } from '../../utils/notify';
import api from '../../api';
import RequiredAsterisk from '../forms/RequiredAsterisk';
import { FormattedMessage } from 'react-intl';

const PasswordChangePanel = () => {

  const _handleSubmit = async (values, setSubmitting, resetForm) => {
    setSubmitting(true);
    try {
      const data = {
        new_password1: values.newPass,
        new_password2: values.confirmPass,
        old_password: values.currentPass,
      };
      const result = await api
        .post({}, `/v1/auth/password/change/`, data);
      setSubmitting(false);
      if (result.status !== 200) {
        localizedNotifyError('passwordResetFailed');
      } else {
        resetForm();
        localizedNotifySuccess('passwordResetSuccess');
      }
    } catch (e) {
      setSubmitting(false);
      localizedNotifyError('passwordResetFailed');
      throw new Error(e);
    }
  };

  const formValidationSchema = object().shape({
    currentPass: string().required('required'),
    newPass: string().required('required')
      .min(6, 'registrationFailedShortPassword')
      .matches(/^[^\s].+[^\s]$/, 'passwordNoSpacesAllowedAround'),
    confirmPass: string()
      .oneOf([ref('newPass')], 'passwordMismatch')
      .required('required'),
  });


  return (
    <div>
      <h2><FormattedMessage id="changePasswordTab" /></h2>
      <Formik
        initialValues={{
          currentPass: '',
          newPass: '',
          confirmPass: '',
        }}
        validationSchema={formValidationSchema}
      >
        {({
            touched,
            dirty,
            errors,
            values,
            resetForm,
            isValid,
            handleChange,
            setSubmitting,
            isSubmitting,
          }) => {
          return (
            <FormWrapperDiv>
              <StyledForm autoComplete="off" className="hds-form hds-form--login">
                <div className="hds-text-input">
                  <label htmlFor="currentPass">{getMessage('currentPassword')}<RequiredAsterisk /></label>
                  <Field
                    required
                    id="currentPass"
                    name="currentPass"
                    className="form-control"
                    type="password"
                    autoComplete="off"
                    disabled={isSubmitting}
                  />
                  <FormHelperText
                    error={Boolean(touched.currentPass && errors.currentPass)}
                  >
                    {touched.currentPass && errors.currentPass
                      ? getMessage(errors.currentPass)
                      : ' '}
                  </FormHelperText>
                </div>
                <div className="hds-text-input">
                  <label htmlFor="newPass">{getMessage('newPassword')}<RequiredAsterisk /></label>
                  <Field
                    required
                    id="newPass"
                    name="newPass"
                    className="form-control"
                    type="password"
                    autoComplete="off"
                    onChange={handleChange}
                    disabled={isSubmitting}
                  />
                  <FormHelperText
                    error={Boolean(touched.newPass && errors.newPass)}
                  >
                    {touched.newPass && errors.newPass
                      ? getMessage(errors.newPass)
                      : ' '}
                  </FormHelperText>
                </div>
                <div className="hds-text-input">
                  <label htmlFor="confirmPass">{getMessage('confirmPassword')}<RequiredAsterisk /></label>
                  <Field
                    required
                    id="confirmPass"
                    name="confirmPass"
                    className="form-control"
                    type="password"
                    autoComplete="off"
                    onChange={handleChange}
                    disabled={isSubmitting}
                  />
                  <FormHelperText
                    error={Boolean(touched.confirmPass && errors.confirmPass)}
                  >
                    {touched.confirmPass && errors.confirmPass
                      ? getMessage(errors.confirmPass)
                      : ' '}
                  </FormHelperText>
                </div>
                <div className="button-wrap">
                  <button
                    onClick={() => _handleSubmit(values, setSubmitting, resetForm)}
                    className="digi-button"
                    disabled={Boolean(!dirty || !isValid || isSubmitting)}
                    style={{ margin: '16px' }}
                  > {getMessage('resetPassword')}</button>
                </div>
              </StyledForm>

            </FormWrapperDiv>
          );
        }}
      </Formik>
    </div>);
};

export default PasswordChangePanel;